import { useEvent } from "@dnd-kit/utilities";
import { useEffect, useMemo } from "react";
import { useSetRecoilState } from "recoil";

import {
  ALLOW_BULK_ACTIONS_REPORTS_IDS_SET,
  REPORT_INNER_IDS_KEY,
  reportSelectedInnerDataIdsByReportIdAF,
  ReportTemplateIdEnum,
  unique,
} from "@ryde/shared";

import { useReportsContext } from "../../contexts";

export const useBulkReportActions = () => {
  const { reportId, reportDto, reportRows, reportTemplate } =
    useReportsContext();

  const setReportSelectedInnerDataIds = useSetRecoilState(
    reportSelectedInnerDataIdsByReportIdAF(reportId),
  );

  const isBulkActionButtonShown = useMemo(
    () =>
      Boolean(reportTemplate?.id) &&
      ALLOW_BULK_ACTIONS_REPORTS_IDS_SET.has(
        reportTemplate?.id as ReportTemplateIdEnum,
      ),
    [reportTemplate?.id],
  );

  const innerReportItemsIds = useMemo<number[]>(
    () =>
      unique(
        reportRows?.flatMap(r =>
          r[REPORT_INNER_IDS_KEY]?.split(",")
            ?.map(Number)
            .filter(Number.isFinite),
        ) ?? [],
      ),

    [reportRows],
  );

  const handleBulkActionClick = useEvent((): void => {
    setReportSelectedInnerDataIds(innerReportItemsIds);
  });

  useEffect(() => {
    if (!reportTemplate) {
      setReportSelectedInnerDataIds([]);
    }

    return () => {
      setReportSelectedInnerDataIds([]);
    };
  }, [reportDto, reportTemplate, setReportSelectedInnerDataIds]);

  return {
    isBulkActionButtonShown,
    handleBulkActionClick,
  };
};
